var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.083,
    height: 38.293,
    viewBox: "0 0 45.083 38.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_gym",
    d: "M25.542,4.916,3,14.311v28.9H48.083v-28.9Zm0,3.759L44.615,16.62V39.741H6.468V16.62ZM18.606,17.2v17.34h3.468V27.6H29.01v6.936h3.468V17.2H29.01v6.936H22.074V17.2Zm-5.2,1.734v5.2H9.936V27.6H13.4v5.2h3.468V18.933Zm20.808,0V32.805h3.468V27.6h3.468V24.135H37.679v-5.2Z",
    transform: "translate(-3 -4.916)",
    fill: "#c58e47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon2);
export default __webpack_public_path__ + "static/media/facilityIcon2.1666b787ed5a9af5cbf2714ea8a5367f.svg";
export { ForwardRef as ReactComponent };